import { io } from "socket.io-client";

function withSocket() {
  const socket = io("https://next-api.heckercare.com/mobile/hms", {
    reconnectionDelayMax: 10000,
  });

  socket.on("error", (err) => {
    console.log(err);
  });

  socket.on("connect", () => {
    console.log("connected");
  });
  socket.on("disconnect", () => {
    console.log("disconnected");
  });

  return socket;
}

export default withSocket;
